import React from 'react';
import { CardImg } from 'reactstrap';
import { Card, CardMedia, CardContent, CardActions, Typography, Button } from "@mui/material";
import { decompressToBase64, formatter } from '../../utils/common'
import Modal from 'react-modal';
import ItemModal from '../Items/ItemModal.js'
import image from "../No_image_available.png";
import { AddToCart, GetCart, GetCount } from '../ShoppingCart/CartHandler.js';
import parse from 'html-react-parser';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import axios from 'axios';
import "./ItemSearchResults"



const apiUrl = process.env.REACT_APP_BASEURL;

function ItemSearchResults(props) {

    const [activeItem, setActiveItem] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const [foundItems, setFoundItems] = useState();
    // const [startCard, setStartCard] = useState(0);
    // const [endCard,setEndCard] = useState(5);
    // const [popCards, setPopCards] = useState(results);
    // const [currPopCards, setCurrPopCards] = useState([]);
    let category = 'All'
    const navigate = useNavigate();
      const [itemQty, setItemQty] = useState(1);

  const addItem = (item) => {
    AddToCart(item.itemDescription, item.images, item.itemNumber, item.price, itemQty);
    props.setCartCount(GetCount());
  };


    const FindItems = () => {

        axios
            .get(apiUrl + `/api/Items/SearchItems?search=${props.search}`, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + props.token.token
                },
            })
            .then((response) => {

                // console.log("Item Search Response:", response.data);

                setFoundItems(response.data);// Make sure response.data is an array

            })
            .catch((error) => {
                console.log(error);
            });
    };


    if (!!sessionStorage.getItem("category")) {
        category = sessionStorage.getItem("category")
    }

    const encodedValue = encodeURIComponent(category);


    useEffect(() => {
        FindItems();
    }, [props.search]);


    let onRequestClose = () => {
        setIsOpen(false);
        // setCartFunc(GetCart);

    }

    let handleClick = (item) => {
        setActiveItem(item);
        setIsOpen(true);
    }

    let handleMenuClick = (catName) => {
        let parentCategory = props.categories.find(category =>
            category.children.some(child => child.name === catName)
        );
        props.setCategory(parentCategory);
        navigate("/CategorySearchResults");

    }



    const renderSearchResults = () => {
        if (foundItems === null) {
            return (<div>Awaiting Search Results.....</div>);
        } else {
            return (
                <div className=" flex flex-wrap justify-center mt-10  gap-4  scroll">
                    
                        {/* <button id="slideLeft" color="primary" onClick ={buttonLeftClick} >{String.fromCharCode(8249)}</button> */}

                        {!!foundItems && foundItems.map(item =>
                            <Card
                                className="w-64 sm:w-56 md:w-60 lg:w-64 h-[350px] rounded-lg overflow-hidden p-2 shadow-md 
                      transition-all duration-300 ease-in-out hover:shadow-[0px_5px_15px_rgba(0,0,0,0.37)] hover:scale-[1.02] 
                      group cursor-pointer flex flex-col justify-between"
                                onClick={() => handleClick(item)}
                            >
                                {/* Image Section */}
                                <div className="h-32 flex justify-center items-center bg-white">
                                    <CardImg
                                        top
                                        className="card-picture"
                                        src={
                                            "data:image/png;base64," +
                                            decompressToBase64(item.images[0]?.compressedImageData)
                                        }
                                        id={item.itemNumber + "Img"}
                                        alt={item.itemNumber}
                                    />
                                </div>

                                {/* Content Section */}
                                <CardContent className="flex flex-col flex-grow justify-between p-2">
                                    <Typography variant="h6" className="font-semibold text-gray-800 text-sm md:text-base">
                                        {item.itemNumber}
                                    </Typography>
                                    <Typography
                                        variant="subtitle2"
                                        className="text-blue-500 cursor-pointer hover:underline text-xs md:text-sm"
                                    >
                                        {item.categoryName}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        className="text-gray-600 mt-1 text-xs md:text-sm line-clamp-2 h-10"
                                    >
                                        {item.itemDescription}
                                    </Typography>
                                    {item.available !== null && (
                                        <Typography variant="body2" className="text-green-600 font-medium text-xs md:text-sm">
                                            {item.available}
                                        </Typography>
                                    )}
                                </CardContent>

                                {/* Price & Action Section */}
                                <CardActions className="p-2 flex justify-between items-center">
                                    <Typography
                                        variant="body1"
                                        className="font-bold text-gray-900 text-sm md:text-base min-w-[50px] text-right"
                                    >
                                        {formatter.format(item.price)}
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className="rounded-full text-xs md:text-sm w-34 h-9 flex justify-center items-center"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            addItem(item);
                                        }}
                                    >
                                        Add to Cart
                                    </Button>
                                </CardActions>
                            </Card>
                        )}
                        {/* <button id="slideRight" color="primary" onClick ={buttonRightClick}>{String.fromCharCode(8250)}</button> */}
                        {isOpen ? <ItemModal setIsSwiper={props.setIsSwiper} isSwiper={props.isSwiper} item={activeItem} onRequestClose={onRequestClose} cartCount={props.cartCount} setCartCount={props.setCartCount} /> : null}
                    
                </div>
            )
        }
    }
    return (<div>{renderSearchResults()}</div>)
}
export default ItemSearchResults;